import React from 'react';
import { Search, MapPin, Navigation } from 'lucide-react';

export const ExploreFeature = () => (
    <section style={{ padding: '120px 0', borderTop: '1px solid var(--border-subtle)', background: 'var(--bg-primary)', position: 'relative' }}>
        <div className="container">
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: '64px', alignItems: 'center' }}>
                <div style={{ position: 'relative' }}>
                    <div style={{ display: 'inline-block', padding: '6px 16px', background: 'rgba(139, 92, 246, 0.1)', borderRadius: '24px', border: '1px solid rgba(139, 92, 246, 0.2)', marginBottom: '32px', color: 'var(--accent-secondary)', fontSize: '0.875rem', fontWeight: 600 }}>
                        📍 New: Explore Feature
                    </div>
                    <h2 style={{ fontSize: 'clamp(2.5rem, 5vw, 3.5rem)', letterSpacing: '-0.02em', marginBottom: '24px', lineHeight: 1.1 }}>
                        Find What You Crave. <br />
                        <span className="text-gradient-accent">Instantly.</span>
                    </h2>
                    <p style={{ color: 'var(--text-secondary)', fontSize: '1.25rem', lineHeight: 1.6, marginBottom: '32px' }}>
                        Don't move from place to place hoping to find that specific steak or cocktail. Use the Ordabell Explore feature to search for your favorite food or drinks and see exactly which venues nearby serve them.
                    </p>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                        <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
                            <div style={{ background: 'var(--bg-secondary)', padding: '12px', borderRadius: '12px', border: '1px solid var(--border-subtle)' }}>
                                <Search size={24} color="var(--accent-secondary)" />
                            </div>
                            <div>
                                <h4 style={{ fontWeight: 600, marginBottom: '4px' }}>Search by Item</h4>
                                <p style={{ color: 'var(--text-tertiary)', fontSize: '0.925rem' }}>Type in any dish or drink to see a live map of availability.</p>
                            </div>
                        </div>
                        <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
                            <div style={{ background: 'var(--bg-secondary)', padding: '12px', borderRadius: '12px', border: '1px solid var(--border-subtle)' }}>
                                <MapPin size={24} color="var(--accent-secondary)" />
                            </div>
                            <div>
                                <h4 style={{ fontWeight: 600, marginBottom: '4px' }}>Nearby Discovery</h4>
                                <p style={{ color: 'var(--text-tertiary)', fontSize: '0.925rem' }}>See businesses around you that match your exact craving.</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div style={{ position: 'relative' }}>
                    {/* Decorative Blurs */}
                    <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '400px', height: '400px', background: 'var(--accent-secondary)', filter: 'blur(150px)', opacity: 0.1, borderRadius: '50%', zIndex: 0 }}></div>

                    <div className="glass-panel" style={{ position: 'relative', zIndex: 1, padding: '32px', borderRadius: '24px', background: 'rgba(255,255,255,0.02)', border: '1px solid var(--border-focus)' }}>
                        <div style={{ background: 'var(--bg-secondary)', borderRadius: '16px', padding: '24px', border: '1px solid var(--border-subtle)' }}>
                            <div style={{ background: 'var(--bg-tertiary)', borderRadius: '12px', padding: '12px 16px', display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px', border: '1px solid var(--border-light)' }}>
                                <Search size={18} color="var(--text-tertiary)" />
                                <span style={{ color: 'var(--text-tertiary)', fontSize: '0.875rem' }}>Search for "Ribeye Steak"...</span>
                            </div>

                            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                {[
                                    { name: 'The Golden Grill', dist: '0.4 mi away', price: '$$$' },
                                    { name: 'Prime Cuts Lounge', dist: '0.8 mi away', price: '$$' },
                                    { name: 'Skydeck Bistro', dist: '1.2 mi away', price: '$$$$' }
                                ].map((venue, i) => (
                                    <div key={i} className="glass-panel" style={{ padding: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', border: '1px solid var(--border-subtle)', background: 'rgba(255,255,255,0.03)' }}>
                                        <div>
                                            <div style={{ fontWeight: 600, fontSize: '0.925rem' }}>{venue.name}</div>
                                            <div style={{ fontSize: '0.75rem', color: 'var(--text-tertiary)', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                <Navigation size={10} /> {venue.dist}
                                            </div>
                                        </div>
                                        <div style={{ color: 'var(--accent-secondary)', fontWeight: 600 }}>{venue.price}</div>
                                    </div>
                                ))}
                            </div>

                            <div style={{ marginTop: '24px', height: '140px', background: 'var(--bg-tertiary)', borderRadius: '12px', border: '1px solid var(--border-subtle)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <span style={{ color: 'var(--text-tertiary)', fontSize: '0.75rem' }}>[ Interactive Discovery Map ]</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
);
